import { render, staticRenderFns } from "./PubList.vue?vue&type=template&id=2ab95b84&"
import script from "./PubList.vue?vue&type=script&lang=js&"
export * from "./PubList.vue?vue&type=script&lang=js&"
import style0 from "./PubList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports